import didomiModule from './modules';
import { Didomi } from './didomi';
const { containers: DidomiContainer } = didomiModule;
export { DidomiContainer, Didomi };
export default didomiModule;
